module.exports = __webpack_public_path__ + "static/media/carousal_4_desktop.84e8e867.jpg";